export default __webpack_public_path__ + "static/media/Y_wdt_c_cap_0.cc036a33.mp3";